import { PlayerUser } from './player-user.model';
import { AnyHash } from '@hidat/huijs-common';
import { PlayerStation } from './player-station.model';
import {PlayerUserMix} from "./user-mix.model";
import { Expose, Type } from 'class-transformer';

/**
 * Instance User
 * This is a hybrid instance/user which includes all the bookmarks, liked sets, etc. for the given instances user.
 */
export class InstanceUser {
  // Instance ID
  @Expose({ name: 'id' })
  id = -1;

  // Guid
  @Expose({ name: 'listener_id' })
  listenerId: string | undefined = undefined;
  @Expose({ name: '_bookmarked_count' })
  _bookmarkedCount = 0;
  @Expose({ name: '_liked_count' })
  _likedCount = 0;
  @Expose({ name: '_liked_duration' })
  _likedDuration = 0;
  @Expose({ name: '_mix_count' })
  _mixCount = 0;

  @Expose({ name: '_user' })
  @Type(() => PlayerUser)
  _user: PlayerUser | undefined = undefined;
  @Expose({ name: '_station' })
  @Type(() => PlayerStation)
  _station: PlayerStation | undefined = undefined;

  //@TODO
  _bookmarks: AnyHash[] = [];
  _likedSets: AnyHash[] = [];
  @Expose({ name: '_user_mixes' })
  @Type(() => PlayerUserMix)
  _userMixes: PlayerUserMix[] = [];
}
